import Vue from 'vue';

const deletePromptMixin = Vue.extend({
    methods: {
        promptDelete(): Promise<boolean> {
            const deleteConfirmMessage = this.$i18n.t('common.deletePrompt').toString();
            const deleteButton = this.$i18n.t('common.delete').toString();
            const cancelButton = this.$i18n.t('common.cancel').toString();

            return this.$bvModal.msgBoxConfirm(
                deleteConfirmMessage,
                {
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    cancelVariant: 'info',
                    okTitle: deleteButton,
                    cancelTitle: cancelButton,
                    centered: true
                }
            );
        }
    }
});

export default deletePromptMixin;
